import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";
import "./styles/OrderDetails.css";

/* ── MOCK DATA ── */
const ORDERS_DB = {
  "ORD-2024-001": {
    id: "ORD-2024-001",
    date: "12 Jan 2025",
    status: "Delivered",
    deliveredOn: "16 Jan 2025",
    paymentMethod: "UPI",
    paymentStatus: "Paid",
    subtotal: 21900,
    shipping: 0,
    tax: 3942,
    total: 25842,
    address: {
      name: "Rahul Sharma",
      line1: "42, Sector 15, Vasundhara",
      city: "Ghaziabad, Uttar Pradesh",
      pincode: "201012",
      phone: "+91 98765 43210",
    },
    items: [
      { name: "Vacuum Pump", brand: "Value", qty: 1, price: 14250 },
      { name: "Manifold Gauge", brand: "Camipro", qty: 1, price: 2950 },
      { name: "Tube Bender", brand: "Galaxy", qty: 2, price: 2350 },
    ],
    timeline: [
      { label: "Order Placed",   date: "12 Jan 2025, 10:32 AM", done: true },
      { label: "Confirmed",      date: "12 Jan 2025, 11:00 AM", done: true },
      { label: "Dispatched",     date: "13 Jan 2025, 2:15 PM",  done: true },
      { label: "Out for Delivery", date: "16 Jan 2025, 9:00 AM", done: true },
      { label: "Delivered",      date: "16 Jan 2025, 1:30 PM",  done: true },
    ],
  },
  "ORD-2024-002": {
    id: "ORD-2024-002",
    date: "28 Feb 2025",
    status: "Shipped",
    deliveredOn: null,
    paymentMethod: "Credit Card",
    paymentStatus: "Paid",
    subtotal: 42450,
    shipping: 0,
    tax: 7641,
    total: 50091,
    address: {
      name: "Rahul Sharma",
      line1: "42, Sector 15, Vasundhara",
      city: "Ghaziabad, Uttar Pradesh",
      pincode: "201012",
      phone: "+91 98765 43210",
    },
    items: [
      { name: "Scroll Compressor", brand: "Copeland", qty: 1, price: 39500 },
      { name: "Manifold Gauge", brand: "Camipro", qty: 1, price: 2950 },
    ],
    timeline: [
      { label: "Order Placed", date: "28 Feb 2025, 3:10 PM", done: true },
      { label: "Confirmed",    date: "28 Feb 2025, 4:00 PM", done: true },
      { label: "Dispatched",   date: "1 Mar 2025, 10:00 AM", done: true },
      { label: "Out for Delivery", date: "Expected 6 May 2025", done: false },
      { label: "Delivered",    date: "—", done: false },
    ],
  },
  "ORD-2024-003": {
    id: "ORD-2024-003",
    date: "05 Apr 2025",
    status: "Processing",
    deliveredOn: null,
    paymentMethod: "Net Banking",
    paymentStatus: "Paid",
    subtotal: 16270,
    shipping: 0,
    tax: 2929,
    total: 19199,
    address: {
      name: "Rahul Sharma",
      line1: "42, Sector 15, Vasundhara",
      city: "Ghaziabad, Uttar Pradesh",
      pincode: "201012",
      phone: "+91 98765 43210",
    },
    items: [
      { name: "R-410A Refrigerant Cylinder", brand: "Godrej", qty: 1, price: 11800 },
      { name: "R-134A Refrigerant Gas Can", brand: "Floron", qty: 2, price: 780 },
      { name: "Air Conditioner Stabilizer 1 KVA", brand: "Camipro", qty: 1, price: 2290 },
      { name: "Tube Cutter", brand: "Galaxy", qty: 1, price: 620 },
    ],
    timeline: [
      { label: "Order Placed", date: "5 Apr 2025, 8:45 PM", done: true },
      { label: "Confirmed",    date: "5 Apr 2025, 9:00 PM", done: true },
      { label: "Dispatched",   date: "Expected 7 Apr 2025",  done: false },
      { label: "Out for Delivery", date: "—", done: false },
      { label: "Delivered",    date: "—", done: false },
    ],
  },
  "ORD-2024-004": {
    id: "ORD-2024-004",
    date: "18 Apr 2025",
    status: "Cancelled",
    deliveredOn: null,
    paymentMethod: "UPI",
    paymentStatus: "Refunded",
    subtotal: 11200,
    shipping: 0,
    tax: 0,
    total: 11200,
    address: {
      name: "Rahul Sharma",
      line1: "42, Sector 15, Vasundhara",
      city: "Ghaziabad, Uttar Pradesh",
      pincode: "201012",
      phone: "+91 98765 43210",
    },
    items: [
      { name: "Rotary Compressor", brand: "Camipro", qty: 1, price: 11200 },
    ],
    timeline: [
      { label: "Order Placed", date: "18 Apr 2025, 5:00 PM", done: true },
      { label: "Cancelled",    date: "18 Apr 2025, 5:30 PM", done: true },
    ],
  },
};

const STATUS_COLOR = {
  Delivered:  { color: "#5de0a0", icon: <CheckCircleIcon /> },
  Shipped:    { color: "#72b8ff", icon: <LocalShippingIcon /> },
  Processing: { color: "#D4A017", icon: <HourglassTopIcon /> },
  Cancelled:  { color: "#ff6b6b", icon: <CancelIcon /> },
};

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const order = ORDERS_DB[id];

  if (!order) {
    return (
      <div className="od-root">
        <button className="od-back-btn" onClick={() => navigate("/dashboard/orders")}>
          <ArrowBackIcon style={{ fontSize: 18 }} /> Back to Orders
        </button>
        <div className="od-not-found">Order not found.</div>
      </div>
    );
  }

  const s = STATUS_COLOR[order.status];

  return (
    <div className="od-root">
      {/* ── BACK ── */}
      <button className="od-back-btn" onClick={() => navigate("/dashboard/orders")}>
        <ArrowBackIcon style={{ fontSize: 18 }} /> Back to Orders
      </button>

      {/* ── HEADER ── */}
      <div className="dash-page-header">
        <div className="od-title-row">
          <h1 className="dash-page-title">{order.id}</h1>
          <span className="od-status-badge" style={{ color: s.color, borderColor: `${s.color}44`, background: `${s.color}18` }}>
            {React.cloneElement(s.icon, { style: { fontSize: 15 } })}
            {order.status}
          </span>
        </div>
        <p className="dash-page-sub">Placed on {order.date}</p>
      </div>

      <div className="od-grid">

        {/* ── LEFT COLUMN ── */}
        <div className="od-left">

          {/* Items */}
          <div className="od-card">
            <div className="od-card-title">Items Ordered</div>
            <div className="od-items">
              {order.items.map((item, i) => (
                <div key={i} className="od-item">
                  <div className="od-item-icon">
                    {item.name.charAt(0)}
                  </div>
                  <div className="od-item-info">
                    <div className="od-item-name">{item.name}</div>
                    <div className="od-item-brand">{item.brand} · Qty: {item.qty}</div>
                  </div>
                  <div className="od-item-price">₹ {(item.price * item.qty).toLocaleString("en-IN")}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Tracking timeline */}
          <div className="od-card">
            <div className="od-card-title">Order Timeline</div>
            <div className="od-timeline">
              {order.timeline.map((step, i) => (
                <div key={i} className={`od-step${step.done ? " od-step--done" : ""}`}>
                  <div className="od-step-dot">
                    {step.done && <CheckCircleIcon style={{ fontSize: 18 }} />}
                  </div>
                  {i < order.timeline.length - 1 && (
                    <div className={`od-step-line${step.done ? " od-step-line--done" : ""}`} />
                  )}
                  <div className="od-step-info">
                    <div className="od-step-label">{step.label}</div>
                    <div className="od-step-date">{step.date}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── RIGHT COLUMN ── */}
        <div className="od-right">

          {/* Price breakdown */}
          <div className="od-card">
            <div className="od-card-title">Price Breakdown</div>
            <div className="od-price-rows">
              <div className="od-price-row">
                <span>Subtotal</span>
                <span>₹ {order.subtotal.toLocaleString("en-IN")}</span>
              </div>
              <div className="od-price-row">
                <span>Shipping</span>
                <span className="od-free">{order.shipping === 0 ? "FREE" : `₹ ${order.shipping}`}</span>
              </div>
              <div className="od-price-row">
                <span>Tax (GST)</span>
                <span>₹ {order.tax.toLocaleString("en-IN")}</span>
              </div>
              <div className="od-divider" />
              <div className="od-price-row od-price-row--total">
                <span>Total</span>
                <span>₹ {order.total.toLocaleString("en-IN")}</span>
              </div>
            </div>
          </div>

          {/* Payment */}
          <div className="od-card">
            <div className="od-card-title">Payment</div>
            <div className="od-info-rows">
              <div className="od-info-row">
                <span className="od-info-label">Method</span>
                <span className="od-info-val">{order.paymentMethod}</span>
              </div>
              <div className="od-info-row">
                <span className="od-info-label">Status</span>
                <span className={`od-payment-status od-payment-status--${order.paymentStatus.toLowerCase()}`}>
                  {order.paymentStatus}
                </span>
              </div>
            </div>
          </div>

          {/* Delivery address */}
          <div className="od-card">
            <div className="od-card-title">Delivery Address</div>
            <div className="od-address">
              <div className="od-addr-name">{order.address.name}</div>
              <div className="od-addr-line">{order.address.line1}</div>
              <div className="od-addr-line">{order.address.city} — {order.address.pincode}</div>
              <div className="od-addr-phone">{order.address.phone}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;